// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-view-container {
  padding: 20px;
}

.message-view-header {
  margin-bottom: 20px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.message-view-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.message-details-row {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
}

.message-info-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.message-text {
  margin: 15px 0;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 6px;
}

.message-metadata {
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #666;
}

.message-statistics {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.stats-card {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.stat-item {
  padding: 15px;
  border-radius: 8px;
  background: #f8f9fa;
}

.stat-value {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 24px;
  font-weight: bold;
  margin-top: 10px;
}

.status-breakdown {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.status-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  background: #fff;
  border-radius: 4px;
}

.recipients-section {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.recipients-table {
  width: 100%;
  border-collapse: collapse;
}

.recipients-table th,
.recipients-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  text-transform: capitalize;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.status-badge.status-sent {
  background: #e8f5e9;
  color: #2e7d32;
}

.status-badge.status-draft {
  background: #e3f2fd;
  color: #1976d2;
}

.status-badge.status-failed {
  background: #ffebee;
  color: #c62828;
}

.status-badge.status-pending {
  background: #fff3e0;
  color: #ed6c02;
}

.back-button {
  margin-right: 16px;
  color: #666;
  text-decoration: none;
}

.back-button:hover {
  color: #333;
}

.message-status {
  margin-left: auto;
}

.message-not-found {
  text-align: center;
  padding: 40px;
  font-size: 18px;
  color: #666;
}

.message-metadata-span {
  font-weight: bold;
  font-size: 12px;
  margin-left: 4px;
}`, "",{"version":3,"sources":["webpack://./src/App/components/Messages/messageView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".message-view-container {\n  padding: 20px;\n}\n\n.message-view-header {\n  margin-bottom: 20px;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.message-view-content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.message-details-row {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 24px;\n}\n\n.message-info-card {\n  background: #fff;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.message-text {\n  margin: 15px 0;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 6px;\n}\n\n.message-metadata {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  color: #666;\n}\n\n.message-statistics {\n  background: #fff;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.stats-card {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.stat-item {\n  padding: 15px;\n  border-radius: 8px;\n  background: #f8f9fa;\n}\n\n.stat-value {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 24px;\n  font-weight: bold;\n  margin-top: 10px;\n}\n\n.status-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.status-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n  background: #fff;\n  border-radius: 4px;\n}\n\n.recipients-section {\n  background: #fff;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.recipients-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.recipients-table th,\n.recipients-table td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.status-badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  text-transform: capitalize;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.status-badge.status-sent {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.status-badge.status-draft {\n  background: #e3f2fd;\n  color: #1976d2;\n}\n\n.status-badge.status-failed {\n  background: #ffebee;\n  color: #c62828;\n}\n\n.status-badge.status-pending {\n  background: #fff3e0;\n  color: #ed6c02;\n}\n\n.back-button {\n  margin-right: 16px;\n  color: #666;\n  text-decoration: none;\n}\n\n.back-button:hover {\n  color: #333;\n}\n\n.message-status {\n  margin-left: auto;\n}\n\n.message-not-found {\n  text-align: center;\n  padding: 40px;\n  font-size: 18px;\n  color: #666;\n}\n\n.message-metadata-span {\n  font-weight: bold;\n  font-size: 12px;\n  margin-left: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
